if (!customElements.get('component-product-card-wishlist')) {
  customElements.define('component-product-card-wishlist', class ProductCardWishlistComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.swymNotification = document.querySelector("swym-notification");
      this.wishlistButton = this.querySelector('button');
      this.addEventListeners();
      this.getListContentsAndInitWishlist();
    }

    async getListContentsAndInitWishlist() {
      const listContents = await app.swymApi.getListContents();
      this.initWishlist(listContents);
    }

    initWishlist(listContents) {
      if(this.wishlistButton.dataset.action === 'add') {
        this.checkDisabled(listContents);
      }
      this.wishlistButton.classList.remove('loading');
    }

    checkDisabled(listContents) {
      const wishlistButton = this.wishlistButton;

      const wishlistListVariantIdList = listContents.map((wishlist) => wishlist.epi);
      const currentVariantId = +wishlistButton.dataset.variantId;
      if(wishlistListVariantIdList.indexOf(currentVariantId) !== -1) {
        wishlistButton.classList.add('disable');
      } else { 
        wishlistButton.classList.remove('disable');
      }
    }

    async addToWishList(product) {
      if(this.wishlistButton.dataset.loading) return; 
      this.wishlistButton.dataset.loading = true;
      
      let listContent = await app.swymApi.addToList(product);
      this.swymNotification.show({
        text: '<strong>' +  listContent.cprops.title + ' - ' + listContent.cprops.variantTitle + '</strong>' + ' has been added to ' + '<strong>Wishlist</strong>'  + ' successfully',
        imageURL: listContent.cprops.imageURL
      })
      this.wishlistButton.classList.add('disable');
      this.wishlistButton.removeAttribute('data-loading');
      if(this.wishlistButton.dataset.position === 'drawer') {
        document.querySelector('cart-drawer').showWishlist();
      }
    }

    async removeFromWishList(product) {
      if(this.wishlistButton.dataset.loading) return; 
      this.wishlistButton.dataset.loading = true;
      
      await app.swymApi.deleteFromList(product);
      this.wishlistButton.classList.remove('disable');
      this.wishlistButton.removeAttribute('data-loading');
    }

    addEventListeners() {
      this.wishlistButton && this.wishlistButton.addEventListener('click', (evt) => {
        evt.preventDefault();
        const productCardItem = this.closest('product-card-item');
        let productId = this.children[0].dataset.productId,
            variantId = this.children[0].dataset.variantId,
            productURL = this.children[0].dataset.productUrl,
            variantTitle = this.children[0].dataset.variantTitle,
            imageURL = this.children[0].dataset.productImage,
            title = this.children[0].dataset.title;
        
        if(this.wishlistButton.classList.contains('disable')) {
          this.removeFromWishList({
            epi: +variantId,
            empi: +productId,
            du: location.origin + productURL,
          });
        }
        else if(evt.currentTarget.dataset.action === 'add') {
          this.addToWishList({
            epi: +variantId,
            empi: +productId,
            du: location.origin + productURL,
            cprops: {
              title: title,
              variantTitle: variantTitle,
              imageURL: imageURL
            }
          });
        }
        else if(productCardItem) {
          productCardItem.openVariantsPopup(this.dataset.variantsPopupId, this.wishlistButton);
        }
        else { 
          alert('Please select the variant.');
        }
      })
    }
  });
};

if (!customElements.get('swym-notification')) {
  class swymNotification extends HTMLElement {
    constructor() {
      super();
      this.container = this.children[0];
    }

    connectedCallback() {
      let closeBtn;
      let hearth = document.querySelector('.btn.heart');
      this.addEventListener('click', (event) => {
        closeBtn = event.target.closest('.swym-notification-close');
        if(closeBtn) {
          return this.container.classList.remove('swym-showing');
        }
        const isNotificationPopupCalledFromPopupClicks = this.dataset.position == 'from-popup';
        hearth && !isNotificationPopupCalledFromPopupClicks && hearth.click();
      });
    }

    show(contentData) {
      let textElement = this.container.children[0].lastElementChild;
      let imagelement = textElement.previousElementSibling;
      textElement.innerHTML = contentData.text;
      imagelement.src = contentData.imageURL;
      this.container.classList.add('swym-showing');
      imagelement.onload = null;
      setTimeout(() => {
        this.container.classList.remove('swym-showing');
        this.dataset.position === 'from-popup' ? this.removeAttribute('data-position') : null;
      }, 3000);
    }
  }

  customElements.define('swym-notification', swymNotification);
}
